import { knowledgeBaseToast } from 'helpers/toastMessages';

export const headerData = {
  tableName: 'Knowledge Base',
  hasSearch: true,
  hasDelete: true,
  hasPaging: true,
  isEdge: true,
  // hasCheckbox: true,
  hasExtensionType: true,
  deleteSubtext: knowledgeBaseToast.deleteConfirmation,
  fields: [
    {
      isPrimary: true,
      fieldName: 'folderName',
      headerName: 'Folder Name',
      hasSvg: true,
      primeIcon: 'folder',
      secondaryIcon: 'table-file',
    },
    {
      fieldName: 'dataType',
      headerName: 'Data Type',
      isDataType: true,
    },
    {
      fieldName: 'createdOn',
      headerName: 'Created On',
      isDatetime: true,
      isDesc: true,
      hasSort: true,
    },
    {
      fieldName: 'fileSize',
      headerName: 'File Size',
      isFileSize: true,
    },
  ],
};
